document.addEventListener('DOMContentLoaded', function () {
  if (window.prScriptsInitDone) return;
  window.prScriptsInitDone = true;
  initReveal();
  initGaleria();
  initVideoSlider();
  initFiguras();
  initOfertas();
  initFaq();
  initResenasMostrarMas();
  initBarraFija();
  initContadores();
  initCountdown();
});

function initCountdown() {
  document.querySelectorAll('[data-pr-countdown]').forEach(function (el) {
    var minutos = parseInt(el.getAttribute('data-pr-countdown-minutos'), 10) || 240;
    var storageKey = 'pr_countdown_end_' + minutos;
    var end = parseInt(localStorage.getItem(storageKey), 10);
    var now = Date.now();
    if (!end || end < now) {
      end = now + minutos * 60000;
      localStorage.setItem(storageKey, String(end));
    }
    var dias = el.querySelector('[data-pr-cd-dias]');
    var horas = el.querySelector('[data-pr-cd-horas]');
    var min = el.querySelector('[data-pr-cd-min]');
    var seg = el.querySelector('[data-pr-cd-seg]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var restante = end - Date.now();
      if (restante <= 0) {
        localStorage.removeItem(storageKey);
        restante = 0;
      }
      var s = Math.floor(restante / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      if (dias) dias.textContent = pad(d);
      if (horas) horas.textContent = pad(h);
      if (min) min.textContent = pad(m);
      if (seg) seg.textContent = pad(sec);
    }
    tick();
    setInterval(tick, 1000);
  });
}

function initReveal() {
  var els = document.querySelectorAll('.pr-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('pr-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('pr-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px 800px 0px', threshold: 0 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleria() {
  document.querySelectorAll('[data-pr-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-pr-galeria-principal]');
    var botones = galeria.querySelectorAll('[data-pr-galeria-thumb]');
    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-pr-galeria-thumb');
        if (principal && src) principal.src = src;
        botones.forEach(function (b) { b.classList.remove('pr-activa'); });
        btn.classList.add('pr-activa');
      });
    });
  });
}

function initVideoSlider() {
  document.querySelectorAll('[data-pr-video-slider]').forEach(function (slider) {
    var videos = Array.from(slider.querySelectorAll('video'));
    if (!videos.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          videos.forEach(function (v) { if (v !== video) v.pause(); });
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { root: slider, threshold: [0, 0.6, 1] });

    videos.forEach(function (v) { observer.observe(v); });
  });
}

function initFiguras() {
  document.querySelectorAll('[data-pr-figuras]').forEach(function (wrap) {
    var comprar = wrap.closest('[data-pr-comprar]');
    if (!comprar) return;
    var form = comprar.querySelector('[data-pr-form]');
    var mainImg = comprar.querySelector('[data-pr-galeria-principal]');
    var pills = wrap.querySelectorAll('[data-pr-figura]');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('pr-figura-activa'); });
        pill.classList.add('pr-figura-activa');
        var variantId = pill.getAttribute('data-pr-variant-id');
        if (form && variantId) form.setAttribute('data-pr-variant-id', variantId);
        var img = pill.getAttribute('data-pr-figura-img');
        if (mainImg && img) mainImg.src = img;
      });
    });
  });
}

function initOfertas() {
  document.querySelectorAll('[data-pr-comprar]').forEach(function (root) {
    var cards = root.querySelectorAll('[data-pr-oferta]');
    var addonRows = root.querySelectorAll('[data-pr-addon-row]');
    var form = root.querySelector('[data-pr-form]');
    if (!cards.length || !form) return;

    function seleccionar(card) {
      cards.forEach(function (c) { c.classList.remove('pr-oferta-activa'); });
      card.classList.add('pr-oferta-activa');
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-pr-addon-row]')) return;
        if (e.target.closest('[data-pr-oferta-mix]')) return;
        seleccionar(card);
      });
    });

    addonRows.forEach(function (row) {
      var cb = row.querySelector('[data-pr-addon-checkbox]');
      if (!cb) return;
      row.classList.toggle('pr-addon-marcado', cb.checked);
      cb.addEventListener('change', function () {
        row.classList.toggle('pr-addon-marcado', cb.checked);
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var activa = root.querySelector('.pr-oferta-activa');
      if (!activa) return;
      var qty = parseInt(activa.getAttribute('data-pr-qty'), 10) || 1;
      var discountCode = activa.getAttribute('data-pr-code') || '';
      var variantId = form.getAttribute('data-pr-variant-id');
      var items = [{ id: variantId, quantity: qty }];

      var mixSelects = activa.querySelectorAll('[data-pr-mix-select]');
      if (mixSelects.length) {
        items = Array.from(mixSelects).map(function (sel) {
          return { id: sel.value, quantity: 1 };
        });
      }

      var addonCheckboxesCompartidos = root.querySelectorAll('[data-pr-addon-checkbox]');
      addonCheckboxesCompartidos.forEach(function (cb) {
        if (cb.checked) {
          var addonVariantId = cb.getAttribute('data-pr-addon-variant-id');
          if (addonVariantId) items.push({ id: addonVariantId, quantity: 1 });
        }
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (discountCode) {
            window.location.href = '/discount/' + discountCode + '?redirect=/cart';
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          window.location.href = '/cart';
        });
    });
  });
}

function initFaq() {
  document.querySelectorAll('.pr-faq-item').forEach(function (item) {
    var boton = item.querySelector('.pr-faq-pregunta');
    var respuesta = item.querySelector('.pr-faq-respuesta');
    if (!boton || !respuesta) return;
    boton.addEventListener('click', function () {
      var abierta = item.classList.contains('pr-faq-abierta');
      item.closest('.pr-faq-lista').querySelectorAll('.pr-faq-item').forEach(function (i) {
        i.classList.remove('pr-faq-abierta');
        i.querySelector('.pr-faq-respuesta').style.maxHeight = null;
      });
      if (!abierta) {
        item.classList.add('pr-faq-abierta');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

function initBarraFija() {
  var barra = document.querySelector('[data-pr-barra-fija]');
  var ancla = document.getElementById('pr-comprar-ancla');
  if (!barra || !ancla) return;
  var boton = barra.querySelector('[data-pr-barra-boton]');
  if (boton) {
    boton.addEventListener('click', function () {
      ancla.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var pasado = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
      barra.classList.toggle('pr-mostrar', pasado);
    });
  }, { threshold: 0 });
  observer.observe(ancla);
}

function initContadores() {
  var els = document.querySelectorAll('[data-pr-count]');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function animar(el) {
    var target = parseFloat(el.getAttribute('data-pr-count'));
    var decimales = el.getAttribute('data-pr-count-decimals') ? parseInt(el.getAttribute('data-pr-count-decimals'), 10) : 0;
    var sufijo = el.getAttribute('data-pr-count-suffix') || '';
    var duracion = 1200;
    var inicio = null;
    function paso(ts) {
      if (!inicio) inicio = ts;
      var progreso = Math.min((ts - inicio) / duracion, 1);
      var actual = target * (1 - Math.pow(1 - progreso, 3));
      el.textContent = actual.toFixed(decimales) + sufijo;
      if (progreso < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animar(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initResenasMostrarMas() {
  document.querySelectorAll('[data-pr-resenas-boton]').forEach(function (btn) {
    var grid = document.querySelector(btn.getAttribute('data-pr-resenas-boton'));
    if (!grid) return;
    var lote = 1;

    function actualizarBoton() {
      var quedan = grid.querySelector('[data-pr-resena-lote="' + (lote + 1) + '"]');
      btn.style.display = quedan ? '' : 'none';
    }

    btn.addEventListener('click', function () {
      lote += 1;
      var tarjetas = grid.querySelectorAll('[data-pr-resena-lote="' + lote + '"]');
      tarjetas.forEach(function (c) { c.classList.remove('pr-resena-oculta'); });
      actualizarBoton();
    });

    actualizarBoton();
  });
}
